import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';
import {
	COMPANY_PROFILE_FRAGMENT,
	SIMPLE_COMPANY_PROFILE_FRAGMENT,
} from '@app/model/company_profile/service/CompanyProfileGraphQLFragments';


export const FIND_COMPANY_PROFILES_QUERY: GraphQL = {
	name: 'findCompanyProfiles',
	gql: gql`
      ${COMPANY_PROFILE_FRAGMENT}
      query findCompanyProfiles {
          findCompanyProfiles {
              ...CompanyProfileFields
          }
      }

	`,
};
export const FIND_COMPANY_PROFILES_WITH_ACCESS_TO_COMPANY_HOTEL_QUERY: GraphQL = {
	name: 'findCompanyProfilesWithAccessToCompanyHotel',
	gql: gql`
      ${SIMPLE_COMPANY_PROFILE_FRAGMENT}
      query findCompanyProfilesWithAccessToCompanyHotel($companyHotelId: Long!) {
          findCompanyProfilesWithAccessToCompanyHotel(companyHotelId: $companyHotelId) {
              ...SimpleCompanyProfileFields
          }
      }

	`,
};

export const SAVE_COMPANY_PROFILE_MUTATION: GraphQL = {
	name: 'saveCompanyProfile',
	gql: gql`
			${COMPANY_PROFILE_FRAGMENT}
			mutation saveCompanyProfile($input: CompanyProfileInput!) {
					saveCompanyProfile(input: $input) {
							...CompanyProfileFields
					}
			}
	`,
};

export const DISABLE_COMPANY_PROFILE_MUTATION: GraphQL = {
	name: 'disableCompanyProfile',
	gql: gql`
			${COMPANY_PROFILE_FRAGMENT}
			mutation disableCompanyProfile($disableProfileId: Long!) {
          disableCompanyProfile(disableProfileId: $disableProfileId) {
							...CompanyProfileFields
					}
			}
	`,
};
